import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {Card, CardBody, CardTitle, Col, FormGroup, Label, Modal, Row} from 'reactstrap';
import { INTERNATIONAL} from "../../../../components/i18n/i18n";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_SAVE} from "../../../../components/i18n/toolTips";
import Separator from "../../../../components/Separator";
import {FL_ATTRIBS, FL_CATEGORY, FL_STATUS, FL_SUB_CATEGORY} from "../../../../components/i18n/formLabels";
import Switch from "react-bootstrap-switch";
import SelectMultipleGeneric from "../../../../components/select/selectMultipleGeneric";
import {aybAttributeProvider} from "../../../../providers/aybAttributeProvider";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {aybCategoryProvider} from "../../../../providers/aybCategoryProvider";
import {dishDrinkService} from "../../../../jwt/_services/ayb/dishDrinkService";
import {paramSettingsProvider} from "../../../../providers/paramSettingsProvider";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {DishDrinkLangs} from "../../dishDrink/_langs";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import {aybMenuService} from "../../../../jwt/_services/ayb/aybMenuService";


export const SauserSectionForm = forwardRef((props, ref) => {
    const path = props.path ;
    const [parent] = useState(props.parent || null);
    const [category] = useState(props.category || null);
    const [app] = useState(props.app || null);

    const [modal, setModal] = useState(false);

    const [item, setItem] = useState(null);
    const [showOrder, setShowOrder] = useState(0);
    const [status, setStatus] = useState(  true);
    const [langs, setLangs] = useState([]);


    const [categoryId, setCategoryId] = useState(  null);
    const [validCategory, setValidCategory] = useState(  true);
    const [subCategoryId, setSubCategoryId] = useState( null);
    const [selectedAttribs, setSelectedAttribs] = useState( []);
    const [ durationOptions, setDurationOptions ] = useState(  [] );

    useEffect(() => {
    }, []);

    useImperativeHandle(ref, () => ({
        showModal(_item, _index) {

            setItem( _item );
            setShowOrder(_index);
            setLangs(_item?.langs || []);
            setStatus(_item?.id ? _item?.status : true );
            setCategoryId(_item?.category?.id || null);
            setSubCategoryId(_item?.subCategory?.id || null);
            setSelectedAttribs(_item?.attributes || []);
            setDurationOptions(_item?.durationOptions || []);
            setModal(!modal);
        }
    }));

    const onSubmit = (data, _) => {
        if (categoryId === null) {
            setValidCategory(false);
            return;
        }

        const dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            item: {
                status: status,
                showOrder: showOrder,
                aybMenu : { id : parent.id },
                category: { id : categoryId },

                langs: langs,
                attributes: selectedAttribs,
                durationOptions : mergeOptions(durationOptions)
            }
        }

        if (subCategoryId !== undefined && subCategoryId !== null )
            dataRequest.item.subCategory = { id : subCategoryId };
        else
            dataRequest.item.subCategory = null;

        // console.log(dataRequest);
        // return;

        if (item?.id) {
            let id = item.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, dishDrinkService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, dishDrinkService, dataRequest)
        }

        setModal(!modal);
    };

    const mergeOptions = (_durationOptions) => {
        let durationOptionsString = ''

        _durationOptions.map((option) => {
            if (durationOptionsString === '')
                durationOptionsString += option.id;
            else
                durationOptionsString += (',' + option.id);

        });

        return durationOptionsString
    }

    const showModal = () => {
        setModal(!modal);
    }

    const notImplemented = () => {
        console.log('Not implemented')
    }

    const confirmDelete = data => ConfirmDelete({
        path,
        data: { id: item?.id },
        fbDataBaseId: app?.fbDataBase?.id,
        service: dishDrinkService,
        remove : genericIndexedActions.delete,
    } );

    const setCategory = (value) => {
        setValidCategory(true);
        setCategoryId(value)
    }

    return <Modal isOpen={modal} toggle={showModal} modalClassName="menu-modal-form">
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'} > { (parent?.title?.toLowerCase()?.includes('menu') ? '' : 'Menu ') + parent?.title + '  /  ' + (item?.title || item?.name || '') }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { 'uid: ' + (item?.uid || '') }</h5>
                </>
                <div className="top-right">
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        onClick={onSubmit}
                    />
                    {
                        item?.id &&
                        <>
                            {/*<GenericButton*/}
                            {/*    style={'table'}*/}
                            {/*    toolTip={TT_HISTORY}*/}
                            {/*    icon={'fa-clock'}*/}
                            {/*    permission={'search'}*/}
                            {/*    onClick={showHistory}*/}
                            {/*/>*/}
                            <TranslateButton item={item} service={dishDrinkService} />
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_DELETE}
                                icon={'fa-trash'}
                                permission={'delete'}
                                onClick={confirmDelete}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={showModal}
                    />
                </div>
            </CardTitle>
                <CardBody>
                    <Row>
                        {
                            (category === 'REST' || category === 'HCDP_CUISINE;HCDP_BAR;HCDP_INSIDE_HOUSE') ?
                                <Col md="8">
                                    <FormGroup>
                                        <SelectMultipleGeneric
                                            title={ 'Opciones de presentación' }
                                            initialValues={ durationOptions }
                                            setExternalValue={ setDurationOptions }
                                            provider={ paramSettingsProvider }
                                            customFilter={{ item : {ps_key: 'xkynet_config_rest_presentation_options'}} }
                                        />
                                    </FormGroup>
                                </Col>  :
                                (category === 'XPA' || category === 'HCDP_SPA') ?
                                    <Col md="8">
                                        <FormGroup>
                                            <SelectMultipleGeneric
                                                title={ 'Opciones de duración' }
                                                initialValues={ durationOptions }
                                                setExternalValue={ setDurationOptions }
                                                provider={ paramSettingsProvider }
                                                customFilter={{ item : {ps_key: 'xkynet_config_xpa_duration_times'}} }
                                            />
                                        </FormGroup>
                                    </Col> : null

                        }
                        <Col  md="4">
                            <FormGroup>
                                <Label>{ FL_STATUS }</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className={(!validCategory ? 'label-is-invalid' : '')}>{ FL_CATEGORY }</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={ categoryId }
                                    hasError={ !validCategory }
                                    setExternalValue={ value =>  setCategory(value) }
                                    provider = { aybCategoryProvider }
                                    customFilter={{ onlyRegistered:true, fbDataBase: { id: app?.fbDataBase?.id }, item : { category : category}} }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ FL_SUB_CATEGORY }</Label>
                                <SelectGeneric
                                    initialValue={subCategoryId}
                                    setExternalValue={value => setSubCategoryId(value)}
                                    provider={ aybCategoryProvider }
                                    customFilter={{ onlyRegistered:true, fbDataBase: { id: app?.fbDataBase?.id }, item : { category : category}} }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {
                            (category === 'REST' || category === 'HCDP_CUISINE;HCDP_BAR;HCDP_INSIDE_HOUSE') ?
                                <Col md="12">
                                    <FormGroup>
                                        <SelectMultipleGeneric
                                            title={ FL_ATTRIBS }
                                            initialValues={ selectedAttribs }
                                            setExternalValue={ setSelectedAttribs }
                                            provider={ aybAttributeProvider }
                                            maxSelection={ 3 }
                                        />
                                    </FormGroup>
                                </Col> :
                                null

                        }
                    </Row>
                </CardBody>

                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <DishDrinkLangs langs={langs} setLangs={setLangs} translatableLangs={item?.translatedLangs || []} />
                </CardBody>
        </Card>
    </Modal>
})